import { type BoxProps } from '@pets-ui/Box/Box'
import { Box } from '@pets-ui/Box/Box'

export type CartCardBodyProps = BoxProps

export const CartCardBody = (props: CartCardBodyProps) => {
  return (
    <Box p={3} {...props} />
  )
}
